
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const YearlyIncreasedPriceTemp = (props) => {
  const { PropertyProfile, PriceotherDetails,singleProperty } = useSelector(
    (state) => state.Property
  );
  const dispatch = useDispatch();

  const [yearlyRent, setYearlyRent] = useState(singleProperty.yearlyRentCommercial);

  //errors
  const [YearlyRentError, setYearlyRentError] = useState("");

  useEffect(() => {
    if (PriceotherDetails !== "") {
      setYearlyRent(PriceotherDetails.yearlyRent);
    }
  }, [PriceotherDetails]);
 
  return (
    <>
      <div className="Yearly-widget" style={{ marginTop: "10px" }}>
        <div className="widgetbox_white_box__1v7xz undefined false false">
          <div
            className="widgetbox_header_text__2BXc_"
            style={{ marginBottom: "-20px" }}
          >
            <div className="xidHeading_PageHeadingwrap__3z0kL">
              <h4>
                <div className="section_header_semiBold xidHeading_PageHeading__3ZQJk">
                  <span
                    className="xidHeading_headingText__Ulc2a"
                    style={{ display: "inline" }}
                  >
                    Yearly rent is expected to increase by
                  </span>
                </div>
              </h4>
            </div>
            <p style={{ color: "red" }}>{YearlyRentError}</p>
          </div>
        </div>
        <div className="false">
          <div id="DepositValue-input">
            <div className="numberInput_inputContainer__CHL96  numberInput_multiple_input__33UOZ">
              <div className="false">
                <input
                  type="text"
                  value={yearlyRent}
                  onChange={(e) =>{
                    setYearlyRent(e.target.value.replace(/\D/g, ""));
                    props.getYearlyRent(e.target.value.replace(/\D/g, ""))
                  }}
                  placeholder="Percentage (%) of increase in rent"
                />
                <div></div>
                <div className="numberInput_placeholder__2f6Rh caption_strong_large numberInput_placeholderWithoutError__1-IPT"></div>
                <div className="numberInput_iconsWrapper__3Kpm5">
                  <i></i>
                  <div className="screeningActions_iconWrapper__dB1NM"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default YearlyIncreasedPriceTemp;
